// The five mandatory intake fields, and the year bounds, shared by the
// quick-add modal and the (now editable) convert modal.
//
// The bounds mirror `InquiryCreateRequest.year: Field(..., ge=1900, le=2030)`
// in backend/inquiry_models.py, the same way MIN_COMPLAINT_LENGTH mirrors
// JobCreateRequest. Typing `16` for a 2016 Civic is the most likely mistake
// this feature will see -- it happens at the bay, on a phone -- and it
// deserves instant feedback rather than a round trip.

export const MIN_YEAR = 1900;
export const MAX_YEAR = 2030;

export const MANDATORY_FIELDS = [
  ['customer_name', 'Customer name'],
  ['customer_phone', 'Phone number'],
  ['year', 'Year'],
  ['make', 'Make'],
  ['model', 'Model'],
];

/** Labels of the mandatory fields left blank, in field order. */
export const missingMandatory = (form) =>
  MANDATORY_FIELDS.filter(([name]) => !String(form[name] ?? '').trim()).map(
    ([, label]) => label
  );

/** An error message for an out-of-range or non-numeric year, else null. */
export const yearError = (value) => {
  const year = Number(String(value).trim());
  if (!Number.isInteger(year) || year < MIN_YEAR || year > MAX_YEAR) {
    return `Enter the vehicle's full model year, between ${MIN_YEAR} and ${MAX_YEAR}.`;
  }
  return null;
};
